var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberLimitReachedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 146,
    viewBox: "0 0 237 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M180.938 141.008L182.534 141.443",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M229.912 40.2912V132.469C229.912 134.203 229.271 135.792 228.206 137.002L228.2 137.008C226.946 138.447 225.094 139.361 223.02 139.361H150.127C146.318 139.361 143.234 136.277 143.234 132.469V64.2655H137.479C136.168 64.2655 135.382 62.81 136.101 61.7114L143.234 50.8368V40.2912C143.234 36.4824 146.318 33.3984 150.127 33.3984H223.02C226.829 33.3984 229.912 36.4824 229.912 40.2912Z",
    fill: "white",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M186.841 84.1719L184.197 105.982L176.044 114.766L162.939 128.886C157.764 134.474 148.601 133.208 145.127 126.421L130.51 99.1175C130.098 98.3368 130.075 97.4445 130.393 96.6692L128.48 94.6059C127.878 94.0873 127.906 93.1393 128.547 92.6596L136.762 86.4806C137.47 85.9508 138.491 86.3022 138.719 87.161L139.355 89.5757C139.969 89.4307 140.615 89.4977 141.184 89.7653C141.669 89.9829 142.104 90.3397 142.411 90.8304L154.395 109.847L164.779 96.4797C169.508 90.39 176.284 86.2241 183.857 84.7519L186.841 84.1719Z",
    fill: "#FEC54B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M176.044 114.762L162.939 128.882C157.764 134.47 148.601 133.204 145.127 126.417L130.51 99.1136C130.098 98.3329 130.075 97.4406 130.393 96.6653L128.48 94.602C127.878 94.0834 127.906 93.1354 128.547 92.6557L136.762 86.4767C137.47 85.9469 138.491 86.2983 138.719 87.1572L139.355 89.5718C139.968 89.4268 140.615 89.4938 141.184 89.7615C140.933 90.2076 140.627 90.6259 140.275 90.9995C138.881 92.4885 137.03 93.5648 135.97 95.3047C134.269 98.1042 135.117 101.735 136.377 104.757C138.608 110.116 142.088 115.074 146.9 118.32C151.713 121.565 157.942 122.926 163.485 121.203C167.562 119.937 170.975 117.16 174.812 115.28C175.202 115.091 175.615 114.912 176.044 114.762Z",
    fill: "#E2A31B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M184.195 105.978L162.937 128.884C157.76 134.471 148.601 133.206 145.128 126.42L130.51 99.1148C130.095 98.3359 130.073 97.4403 130.395 96.6693L128.481 94.6015C127.878 94.083 127.907 93.1342 128.544 92.6549L136.759 86.4788C137.469 85.9497 138.491 86.3011 138.72 87.1559L139.352 89.5759C140.493 89.3062 141.742 89.7624 142.412 90.8262L154.396 109.847L164.776 96.4766C169.505 90.3857 176.284 86.2189 183.854 84.7507L186.838 84.1719",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M139.353 89.5703L135.188 92.6522",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M228.191 137.003L228.185 137.009C226.931 138.448 225.079 139.362 223.005 139.362H167.6C166.914 138.381 166.496 137.081 166.384 135.381C166.211 132.682 166.178 130.758 166.239 128.426C166.245 128.231 166.256 128.03 166.262 127.83C166.262 127.74 166.267 127.646 166.267 127.557C166.29 126.937 166.317 126.291 166.351 125.588C166.362 125.393 166.373 125.198 166.379 124.997C166.384 124.958 166.384 124.919 166.384 124.874C166.529 121.84 166.758 117.825 167.026 111.579C167.042 111.211 167.059 110.838 167.07 110.453C167.087 110.074 167.104 109.683 167.12 109.282C167.12 109.243 167.126 109.204 167.126 109.165C167.132 109.003 167.137 108.841 167.143 108.674C167.143 108.607 167.148 108.54 167.154 108.467C167.159 108.233 167.171 107.999 167.182 107.759C167.187 107.519 167.199 107.274 167.21 107.029C167.254 105.802 167.299 104.508 167.349 103.131C167.946 85.8707 189.372 78.6544 212.13 87.4154C212.336 87.4935 212.543 87.5827 212.749 87.6775C213.123 87.8448 213.485 88.04 213.842 88.2519C213.998 88.3467 214.154 88.4415 214.311 88.5475C214.472 88.6535 214.628 88.7594 214.785 88.8765C214.818 88.8932 214.851 88.9211 214.879 88.949C214.991 89.0271 215.102 89.1107 215.208 89.2C215.281 89.2502 215.348 89.3059 215.42 89.3728C215.554 89.4788 215.682 89.5903 215.811 89.7018C222.876 95.9812 225.988 110.994 227.332 124.127C227.366 124.428 227.393 124.724 227.421 125.019C227.449 125.32 227.477 125.616 227.505 125.906C227.533 126.201 227.561 126.497 227.583 126.787C227.667 127.696 227.734 128.594 227.795 129.469C227.879 130.568 227.946 131.639 228.001 132.676C228.001 132.754 228.007 132.832 228.013 132.91C228.052 133.63 228.091 134.332 228.118 135.013C228.146 135.693 228.174 136.357 228.191 137.003Z",
    fill: "#FEC54B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M228.185 137.009C226.931 138.448 225.079 139.362 223.005 139.362H167.6C166.914 138.381 166.496 137.081 166.384 135.381C166.211 132.682 166.178 130.758 166.239 128.426C166.245 128.231 166.256 128.03 166.262 127.83C166.262 127.74 166.267 127.646 166.267 127.557C166.29 126.943 166.317 126.291 166.351 125.588C166.362 125.393 166.373 125.198 166.379 124.997C166.384 124.958 166.384 124.919 166.384 124.874C166.535 121.863 166.764 117.847 167.026 111.579C167.042 111.211 167.059 110.838 167.07 110.453C167.087 110.074 167.104 109.683 167.12 109.282C167.12 109.243 167.126 109.204 167.126 109.165C167.137 108.936 167.143 108.702 167.154 108.467C167.159 108.233 167.171 107.999 167.182 107.759C167.187 107.519 167.199 107.274 167.21 107.029C167.254 105.802 167.299 104.508 167.349 103.131C167.946 85.8707 189.372 78.6544 212.13 87.4154C212.336 87.4935 212.543 87.5827 212.749 87.6775C213.123 87.8448 213.485 88.04 213.842 88.2519C213.998 88.3467 214.154 88.4415 214.311 88.5475C214.472 88.6535 214.628 88.7594 214.785 88.8765C214.818 88.8932 214.851 88.9211 214.879 88.949C214.991 89.0271 215.102 89.1107 215.208 89.2C215.281 89.2502 215.348 89.3059 215.42 89.3728C215.554 89.4788 215.682 89.5903 215.811 89.7018C222.893 95.9589 225.999 110.938 227.332 124.127C227.366 124.428 227.393 124.724 227.421 125.019C227.449 125.32 227.477 125.616 227.505 125.906C227.533 126.201 227.561 126.497 227.583 126.787C227.667 127.696 227.734 128.594 227.795 129.469C227.873 130.568 227.94 131.639 228.001 132.676C228.001 132.754 228.007 132.832 228.013 132.91C228.085 134.349 228.146 135.721 228.185 137.009Z",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M226.628 137.059L196.146 142.551C195.276 142.708 194.417 142.451 193.787 141.91L191.227 143.092C190.547 143.505 189.655 143.187 189.393 142.434L186.052 132.714C185.768 131.878 186.415 131.013 187.296 131.058L189.794 131.203C189.844 130.601 190.084 130.026 190.48 129.574C190.486 129.569 190.486 129.569 190.486 129.574C190.843 129.151 191.339 128.827 191.925 128.677L213.713 123.133L198.449 100.704L219.211 93.5938L229.623 112.22L234.458 120.869C238.178 127.517 234.151 135.843 226.628 137.059Z",
    fill: "#FEC54B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M226.628 137.065L196.146 142.558C195.276 142.714 194.417 142.458 193.787 141.917L191.227 143.099C190.547 143.512 189.655 143.194 189.393 142.441L186.052 132.721C185.768 131.884 186.415 131.02 187.296 131.065L189.794 131.21C189.844 130.607 190.084 130.033 190.48 129.581C190.486 129.576 190.486 129.576 190.486 129.581C192.142 130.602 192.94 132.654 194.417 133.959C195.94 135.297 198.059 135.699 200.072 135.933C206.575 136.68 213.222 136.178 219.535 134.466C223.561 133.373 227.811 131.466 229.551 127.68C231.118 124.283 230.236 120.341 229.757 116.632C229.573 115.204 229.489 113.688 229.623 112.227L234.458 120.876C238.178 127.523 234.151 135.849 226.628 137.065Z",
    fill: "#E2A31B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M219.214 93.5938L234.459 120.873C238.18 127.519 234.155 135.844 226.63 137.057L196.149 142.555C195.28 142.71 194.421 142.455 193.787 141.911L191.23 143.094C190.551 143.509 189.657 143.189 189.398 142.435L186.052 132.718C185.768 131.879 186.417 131.015 187.301 131.06L189.797 131.205C189.892 130.036 190.711 128.988 191.93 128.678L213.716 123.135L198.451 100.704",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M189.797 131.219L191.445 136.131",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M213.719 123.141L216.347 126.44",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M128.492 89.9917C128.492 89.9917 124.04 90.3629 121.587 89.1903C118.909 87.9102 116.004 84.9249 117.172 83.963C118.341 83.0011 121.379 87.2731 125.187 85.7911",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M128.492 89.9917C128.492 89.9917 124.04 90.3629 121.587 89.1903C118.909 87.9102 116.004 84.9249 117.172 83.963C118.341 83.0011 121.379 87.2731 125.187 85.7911",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M128.912 90.384C128.912 90.384 124.504 89.6627 122.408 87.9293C120.121 86.037 118.028 82.4354 119.396 81.7861C120.763 81.1369 122.673 86.0191 126.727 85.5064",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M128.912 90.384C128.912 90.384 124.504 89.6627 122.408 87.9293C120.121 86.037 118.028 82.4354 119.396 81.7861C120.763 81.1369 122.673 86.0191 126.727 85.5064",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M124.951 84.5294L128.985 84.1684C128.985 84.1684 124.435 79.3154 127.072 78.8265C130.451 78.1998 134.492 85.6535 134.492 85.6535L135.541 87.3987L129.769 91.824C129.769 91.824 126.277 90.2677 124.366 88.3331C122.28 86.2213 120.558 82.4281 121.984 81.9191C123.409 81.41 124.82 86.4589 128.905 86.3549C127.291 86.3759 126.026 85.6553 124.951 84.5294Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M124.951 84.5294L128.985 84.1684C128.985 84.1684 124.435 79.3154 127.072 78.8265C130.451 78.1998 134.492 85.6535 134.492 85.6535L135.541 87.3987L129.769 91.824C129.769 91.824 126.277 90.2677 124.366 88.3331C122.28 86.2213 120.558 82.4281 121.984 81.9191C123.409 81.41 124.82 86.4589 128.905 86.3549C127.291 86.3759 126.026 85.6553 124.951 84.5294Z",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M128.969 84.1719L130.282 85.3108",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M186.388 133.692C186.388 133.692 179.575 129.623 177.938 131.747C176.617 133.459 180.939 135.45 180.939 135.45C180.939 135.45 177.49 135.983 175.158 135.87C173.289 135.779 172.961 138.307 177 138.353C176.093 138.509 175.209 138.61 174.514 138.576C172.987 138.503 172.699 140.125 174.805 140.794C173.597 141 173.579 142.486 175.716 143.049C174.412 143.713 174.755 145.982 181.739 144.666C184.085 144.224 186.1 143.852 189.151 141.663L186.388 133.692Z",
    fill: "#FFE4AA",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.998 138.356C176.998 138.356 177.611 138.375 178.559 138.273L176.998 138.356ZM174.766 140.826C174.766 140.826 176.334 140.875 178.334 140.401L174.766 140.826ZM175.675 143.08C175.675 143.08 177.244 143.129 179.244 142.654L175.675 143.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.998 138.356C176.998 138.356 177.611 138.375 178.559 138.273M174.766 140.826C174.766 140.826 176.334 140.875 178.334 140.401M175.675 143.08C175.675 143.08 177.244 143.129 179.244 142.654",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M207.143 74.1895C207.073 74.3603 207 74.5253 206.923 74.6888C204.157 80.6412 197.164 83.4114 191.037 80.8836C184.744 78.287 181.744 71.0751 184.341 64.7817C185.425 62.1536 187.309 60.1029 189.602 58.7923C190.477 58.287 191.411 57.8916 192.386 57.6176C194.957 56.8887 197.784 56.9838 200.445 58.0815C200.489 58.1 200.538 58.1201 200.581 58.1425C206.784 60.7872 209.723 67.9366 207.143 74.1895Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M207.146 74.2059C207.079 74.3731 207.007 74.5404 206.929 74.7022C204.163 80.6581 197.169 83.4241 191.041 80.8979C189.345 80.2009 187.89 79.1635 186.719 77.8976C187.533 78.5111 188.436 79.0297 189.423 79.4368C195.547 81.963 202.54 79.1914 205.306 73.2412C205.384 73.0738 205.456 72.9121 205.529 72.7392C207.419 68.1496 206.338 63.0748 203.181 59.6562C207.553 62.952 209.338 68.9025 207.146 74.2059Z",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M207.143 74.1895C207.073 74.3603 207 74.5253 206.923 74.6888C204.157 80.6412 197.164 83.4114 191.037 80.8836C184.744 78.287 181.744 71.0751 184.341 64.7817C185.425 62.1536 187.309 60.1029 189.602 58.7923C190.477 58.287 191.411 57.8916 192.386 57.6176C194.957 56.8887 197.784 56.9838 200.445 58.0815C200.489 58.1 200.538 58.1201 200.581 58.1425C206.784 60.7872 209.723 67.9366 207.143 74.1895Z",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M207.143 74.1895C207.072 74.3603 206.999 74.5253 206.922 74.6888C205.497 74.5099 204.074 74.1375 202.683 73.5634C196.739 71.1112 192.972 65.6103 192.44 59.6206C192.38 58.958 192.361 58.2884 192.385 57.6176C194.957 56.8887 197.784 56.9838 200.444 58.0815C200.489 58.1 200.538 58.1201 200.581 58.1425C206.783 60.7872 209.722 67.9366 207.143 74.1895Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M200.573 58.1497C198.156 59.5426 195.282 60.1041 192.432 59.6278C191.522 59.4806 190.613 59.2248 189.726 58.8589C189.682 58.8404 189.637 58.822 189.594 58.7995C190.469 58.2942 191.403 57.8989 192.378 57.6248C194.949 56.8959 197.776 56.991 200.437 58.0887C200.481 58.1072 200.53 58.1273 200.573 58.1497ZM217.07 64.3409C215.71 67.6359 211.935 69.2056 208.64 67.8461C205.345 66.4867 203.776 62.7118 205.135 59.4168C206.495 56.1216 210.269 54.5518 213.565 55.9113C216.86 57.2708 218.429 61.0457 217.07 64.3409Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M183.844 72.7422C184.544 73.4008 185.436 73.8067 186.587 73.874",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M193.366 69.7163C193.025 70.542 192.081 70.938 191.255 70.5973L189.307 69.7933C188.481 69.4525 188.087 68.5044 188.427 67.6786C188.597 67.2677 188.918 66.9622 189.301 66.8061C189.682 66.6444 190.125 66.6319 190.54 66.8031L192.489 67.6071C193.315 67.9478 193.705 68.8943 193.366 69.7163Z",
    fill: "white",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M191.352 68.7946C191.107 69.3885 190.684 69.8473 190.169 70.1491L189.307 69.7933C188.481 69.4525 188.087 68.5044 188.427 67.6786C188.597 67.2677 188.918 66.9622 189.301 66.8061C189.682 66.6444 190.125 66.6319 190.54 66.8031L191.517 67.2059C191.613 67.7219 191.568 68.2697 191.352 68.7946Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.859 77.3396C204.09 78.6977 205.383 79.6149 206.741 79.384C208.103 79.1525 209.016 77.8603 208.786 76.5022C208.554 75.1403 207.266 74.2262 205.904 74.4577",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.859 77.3396C204.09 78.6977 205.383 79.6149 206.741 79.384C208.103 79.1525 209.016 77.8603 208.786 76.5022C208.554 75.1403 207.266 74.2262 205.904 74.4577",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M205.058 78.437C205.058 79.278 204.38 79.9566 203.543 79.9566C202.706 79.9566 202.023 79.278 202.023 78.437C202.023 77.6005 202.706 76.9219 203.543 76.9219C204.38 76.9219 205.058 77.6005 205.058 78.437Z",
    fill: "#FEC54B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M88.9926 89.7994C83.6264 94.9478 77.0683 99.0194 69.5483 101.53C48.1437 108.693 25.3538 101.119 12.1953 84.2941C17.6584 74.1302 27.1627 66.4651 38.5608 63.4521C40.1095 63.0408 41.6946 62.7142 43.3099 62.4842C45.2882 62.1999 47.3089 62.0547 49.3658 62.0547C52.2577 62.0547 55.083 62.3451 57.8114 62.9016C59.4087 63.2283 60.9695 63.6397 62.4941 64.1419C74.7874 68.165 84.5822 77.6877 88.9926 89.7994Z",
    fill: "#FFCC5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M87.2902 85.7834C82.102 77.6697 74.2092 71.4462 64.8798 68.3926C63.3559 67.8923 61.7972 67.4794 60.1977 67.1536C57.4698 66.5953 54.643 66.3045 51.7523 66.3045C49.6991 66.3045 47.675 66.4499 45.6975 66.7349C44.0805 66.9676 42.4985 67.2932 40.9513 67.7004C29.8828 70.626 20.6057 77.9372 15.0744 87.6621C14.074 86.5862 13.1084 85.4577 12.1953 84.2886C17.6568 74.1274 27.1608 66.4615 38.5608 63.4487C40.108 63.0356 41.6958 62.71 43.307 62.4773C45.2845 62.1923 47.3086 62.0469 49.3676 62.0469C52.2583 62.0469 55.0851 62.3377 57.8129 62.8962C59.4066 63.2218 60.9712 63.6347 62.4951 64.135C73.3949 67.7062 82.3288 75.5932 87.2902 85.7834Z",
    fill: "#D89F23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M47.75 70.9922V77.958C47.75 79.5295 49.024 80.8035 50.5956 80.8035C52.1671 80.8035 53.4411 79.5295 53.4411 77.958V70.9922H47.75Z",
    fill: "white",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M3.86635 68.7731C12.9592 95.9562 42.3712 110.624 69.5543 101.531C78.7889 98.4419 86.5817 93.0054 92.4878 86.1048L106.322 87.9129L99.4321 75.6869C105.446 63.7539 106.886 49.5178 102.312 35.8429C93.2191 8.65979 63.8071 -6.00774 36.624 3.08509C9.44082 12.1779 -5.22645 41.59 3.86635 68.7731Z",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M106.322 87.9109L92.4855 86.102C91.3844 87.3845 90.2228 88.6187 88.9947 89.7984C83.6285 94.9469 77.0704 99.0184 69.5504 101.529C48.1458 108.692 25.3559 101.118 12.1974 84.2931C8.64613 79.7557 5.79658 74.5467 3.8667 68.769C-5.2263 41.5869 9.43863 12.1783 36.6208 3.08545C63.803 -6.00755 93.2175 8.65738 102.31 35.8395C106.884 49.5183 105.444 63.7536 99.4307 75.6841L106.322 87.9109Z",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M43.0259 56.1334C49.3016 52.2549 51.2449 44.0232 47.3664 37.7475C43.4878 31.4717 35.2562 29.5284 28.9804 33.407C22.7047 37.2855 20.7614 45.5172 24.6399 51.7929C28.5185 58.0687 36.7501 60.012 43.0259 56.1334Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M69.3236 55.4364C74.4997 52.2375 76.1025 45.4482 72.9036 40.2721C69.7046 35.0961 62.9154 33.4933 57.7393 36.6922C52.5632 39.8911 50.9604 46.6804 54.1594 51.8565C57.3583 57.0325 64.1476 58.6353 69.3236 55.4364Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3906 39.0479C67.5439 37.9007 69.4083 37.9007 70.5615 39.0479C71.7088 40.2013 71.7028 42.0657 70.5555 43.213C69.4083 44.3602 67.5439 44.3663 66.3906 43.2188",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3906 39.0479C67.5439 37.9007 69.4083 37.9007 70.5615 39.0479C71.7088 40.2013 71.7028 42.0657 70.5555 43.213C69.4083 44.3602 67.5439 44.3663 66.3906 43.2188",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M68.5211 39.1C68.5211 48.7023 60.749 56.4739 51.1576 56.4739C41.5662 56.4739 33.8047 48.7023 33.8047 39.1C33.8047 38.0169 33.8993 36.9545 34.0992 35.9243C35.5821 27.8574 42.6495 21.7578 51.1576 21.7578C51.3786 21.7578 51.6099 21.7578 51.8307 21.7681C54.5756 21.8734 57.1629 22.62 59.4344 23.8504C63.4939 26.0488 66.5755 29.8242 67.8585 34.3468C68.2896 35.8504 68.5211 37.449 68.5211 39.1Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M64.9341 49.6876C61.7638 53.8188 56.7758 56.481 51.1635 56.481C41.573 56.481 33.8125 48.7083 33.8125 39.1056C33.8125 38.0223 33.9043 36.9635 34.1063 35.9292C34.9081 31.5593 37.35 27.7709 40.7712 25.2188C39.1371 27.3425 37.9927 29.8517 37.4908 32.5874C37.2888 33.6157 37.197 34.6807 37.197 35.764C37.197 45.3666 44.9575 53.1393 54.548 53.1393C58.4404 53.1393 62.0392 51.854 64.9341 49.6876Z",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M68.5211 39.1C68.5211 48.7023 60.749 56.4739 51.1576 56.4739C41.5662 56.4739 33.8047 48.7023 33.8047 39.1C33.8047 38.0169 33.8993 36.9545 34.0992 35.9243C35.5821 27.8574 42.6495 21.7578 51.1576 21.7578C51.3786 21.7578 51.6099 21.7578 51.8307 21.7681C54.5756 21.8734 57.1629 22.62 59.4344 23.8504C63.4939 26.0488 66.5755 29.8242 67.8585 34.3468C68.2896 35.8504 68.5211 37.449 68.5211 39.1Z",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M67.8637 34.36C63.7096 34.2018 59.9234 32.5821 57.0102 30.0161C54.5703 27.8495 52.7509 25.0103 51.8359 21.7812C54.5808 21.8865 57.1681 22.6332 59.4397 23.8636C63.4992 26.062 66.5807 29.8374 67.8637 34.36Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M59.4368 23.8504C59.0371 26.0801 58.1959 28.1625 57.0073 30.0029C53.9365 34.8197 48.5308 38.0169 42.3784 38.0169C39.381 38.0169 36.552 37.2595 34.1016 35.9243C35.5845 27.8574 42.6518 21.7578 51.16 21.7578C51.3809 21.7578 51.6123 21.7578 51.8331 21.7681C54.578 21.8734 57.1652 22.62 59.4368 23.8504Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M65.8829 42.5912C65.8829 43.8405 64.8695 44.8539 63.62 44.8539H62.2942C62.2485 44.8539 62.2027 44.8539 62.1571 44.8465C60.9685 44.778 60.0312 43.7951 60.0312 42.5912C60.0312 41.9662 60.2827 41.4026 60.6941 40.9911C61.1056 40.5796 61.6694 40.3281 62.2942 40.3281H63.62C64.641 40.3281 65.5019 41.0063 65.7915 41.9357C65.8524 42.1418 65.8829 42.3624 65.8829 42.5912Z",
    fill: "white",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M65.8587 42.599C65.8587 43.8483 64.8452 44.8617 63.5958 44.8617H62.27C62.2242 44.8617 62.1785 44.8617 62.1328 44.8543C62.1404 43.2084 63.4814 41.875 65.1272 41.875C65.3481 41.875 65.5615 41.8981 65.7672 41.9435C65.8281 42.1496 65.8587 42.3702 65.8587 42.599Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M53.8907 42.5053C53.8907 43.7546 52.8773 44.768 51.6278 44.768H50.3021C50.2563 44.768 50.2105 44.768 50.1649 44.7606C48.9763 44.6921 48.0391 43.7092 48.0391 42.5053C48.0391 41.8803 48.2905 41.3166 48.7019 40.9052C49.1134 40.4937 49.6772 40.2422 50.3021 40.2422H51.6278C52.6488 40.2422 53.5098 40.9204 53.7993 41.8498C53.8602 42.0559 53.8907 42.2765 53.8907 42.5053Z",
    fill: "white",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M53.8977 42.513C53.8977 43.7623 52.8843 44.7758 51.6348 44.7758H50.3091C50.2633 44.7758 50.2175 44.7758 50.1719 44.7683C50.1795 43.1224 51.5205 41.7891 53.1663 41.7891C53.3872 41.7891 53.6006 41.8121 53.8063 41.8575C53.8672 42.0636 53.8977 42.2842 53.8977 42.513ZM54.7 51.1236C54.7158 51.1436 54.7318 51.1634 54.7517 51.1835C55.1617 51.6093 55.6792 51.8243 56.2961 51.8243C56.2961 51.8243 56.2961 51.8243 56.3001 51.8243C56.9689 51.8243 57.5301 51.5815 57.9918 51.2192C59.2656 50.228 59.8069 48.3532 59.8388 48.2459C59.8587 48.1621 59.8268 48.0747 59.7552 48.0269C59.6836 47.979 59.592 47.9831 59.5243 48.0348C59.4089 48.1223 56.7061 50.1843 54.083 47.7124C54.0272 47.6607 53.9436 47.6447 53.872 47.6725C53.7964 47.7044 53.7486 47.772 53.7486 47.8517C53.7446 47.9433 53.6889 50.0053 54.7 51.1236Z",
    fill: "#312814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M55.3438 50.5296C55.3554 50.5443 55.3671 50.5589 55.3817 50.5736C55.6825 50.886 56.0621 51.0437 56.5147 51.0437C56.5147 51.0437 56.5147 51.0437 56.5176 51.0437C57.0082 51.0437 57.4199 50.8656 57.7586 50.5998C57.747 50.5853 57.7353 50.5706 57.7207 50.556C57.4199 50.2436 57.0403 50.0859 56.5877 50.0859C56.5877 50.0859 56.5877 50.0859 56.5848 50.0859C56.0942 50.0859 55.6825 50.264 55.3438 50.5296Z",
    fill: "#FEC54B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4268 40.2667C34.2736 39.1194 32.4092 39.1194 31.2559 40.2667C30.1086 41.4201 30.1146 43.2845 31.2619 44.4317C32.4092 45.579 34.2736 45.5851 35.4268 44.4376",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4268 40.2667C34.2736 39.1194 32.4092 39.1194 31.2559 40.2667C30.1086 41.4201 30.1146 43.2845 31.2619 44.4317C32.4092 45.579 34.2736 45.5851 35.4268 44.4376",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M88.9926 89.7994C83.6264 94.9478 77.0683 99.0194 69.5483 101.53C48.1437 108.693 25.3538 101.119 12.1953 84.2941C19.31 71.0569 33.2852 62.0547 49.3658 62.0547C67.5881 62.0547 83.106 73.6159 88.9926 89.7994Z",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M62.4958 64.1419C61.31 69.738 56.3612 73.7672 50.5957 73.7672C44.576 73.7672 39.47 69.3629 38.5625 63.4521C40.1112 63.0408 41.6963 62.7142 43.3116 62.4842C45.2899 62.1999 47.3106 62.0547 49.3675 62.0547C52.2594 62.0547 55.0847 62.3451 57.8131 62.9016C59.4104 63.2283 60.9712 63.6397 62.4958 64.1419Z",
    fill: "white",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M57.8063 62.9016C57.1892 66.332 54.1945 68.9273 50.5888 68.9273C46.8379 68.9273 43.7463 66.1141 43.3047 62.4842C45.283 62.1999 47.3037 62.0547 49.3606 62.0547C52.2525 62.0547 55.0778 62.3451 57.8063 62.9016Z",
    fill: "#FFE4AA",
    stroke: "#312814",
    strokeWidth: 0.511182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M85.4166 35.8573L83.9067 40.9598C83.7775 41.3966 84.1885 41.8005 84.623 41.6636L89.858 40.0146C92.8698 41.9873 96.5181 43.0668 100.429 42.8727C109.324 42.4312 116.602 35.2598 117.164 26.3724C117.837 15.7096 109.049 6.91985 98.3865 7.59071C89.5358 8.14759 82.3763 15.3675 81.8871 24.2222C81.6454 28.5978 82.9969 32.652 85.4166 35.8573Z",
    fill: "#FFDB8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M92.4173 26.905C93.5711 26.905 94.5065 25.9696 94.5065 24.8158C94.5065 23.6619 93.5711 22.7266 92.4173 22.7266C91.2635 22.7266 90.3281 23.6619 90.3281 24.8158C90.3281 25.9696 91.2635 26.905 92.4173 26.905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M99.5267 26.905C100.681 26.905 101.616 25.9696 101.616 24.8158C101.616 23.6619 100.681 22.7266 99.5267 22.7266C98.3729 22.7266 97.4375 23.6619 97.4375 24.8158C97.4375 25.9696 98.3729 26.905 99.5267 26.905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M106.644 26.905C107.798 26.905 108.733 25.9696 108.733 24.8158C108.733 23.6619 107.798 22.7266 106.644 22.7266C105.49 22.7266 104.555 23.6619 104.555 24.8158C104.555 25.9696 105.49 26.905 106.644 26.905Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberLimitReachedLogo);
export default __webpack_public_path__ + "static/media/memberLimitReachedLogo.184331e8dbf654562f0d8b341553d522.svg";
export { ForwardRef as ReactComponent };